// extracted by mini-css-extract-plugin
export default {"section":"AstVsLangHub-module__section__YjrZa","tableWrapper":"AstVsLangHub-module__tableWrapper__VYPTE"};